import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Modal, Popconfirm, Form, Select, message } from 'antd';
import Highlighter from 'react-highlight-words';
import { useNavigate } from 'react-router-dom';
import { getJournalList } from 'api/journalservice';
import { createJournal } from 'api/journalservice';
import { deleteJournal } from 'api/journalservice';
import { editJournal } from 'api/journalservice';
import '../css/JournalListTable.css';
import Issues from 'views/issues/Issues';
import { Tooltip } from 'antd';
import { getJournalDetails } from 'api/journalservice';

const JournalListTable = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [previewImage, setPreviewImage] = useState(null);
  const showModal = () => setIsModalOpen(true);
  //const handleCancel = () => setIsModalOpen(false);
  const handleCancel = () => {
    setIsModalOpen(false);
    setJournalFormData(null);
    form.resetFields();
    setPreviewImage(null);
  };

  const [isIssueModalOpen, setIsIssueModalOpen] = useState(false);
  const [selectedJournal, setSelectedJournal] = useState(null);
  const showIssueModal = (record) => {
    setSelectedJournal(record);
    setIsIssueModalOpen(true);
  };

  const openIssueModal = (record) => {
    setSelectedJournal(record);
    setIsIssueModalOpen(true);
  };

  const [journalFormData, setJournalFormData] = useState(null);


  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };


  //fetch data from api

  const [data, setData] = useState([]);
  const [journals, setJournals] = useState([]);

  const fetchJournalList = async () => {
    try {
      const result = await getJournalList();
      const rawData = Array.isArray(result?.data) ? result.data : [];
      const safeData = rawData
        .filter(item => item && typeof item === 'object')
        .map((item) => ({
          id: item.id,
          title: item.title,
          abbreviation: item.abbreviations,
          issue: item.issue,
          articles: item.articles,
          coverImage: item.coverImageURL,
          articleCount: item.articleCount,
          description: item.description,
          about: item.about,
          issn: item.issn,
          impactFactor: item.impactFactor,
          onlineISSN: item.onlineISSN,
          issueCount: item.issueCount
        }));
      setData(safeData);
    }
    catch (error) {
      message.error('خطا در دریافت اطلاعات جدول');
      console.error(error);
    }
  }

  const handleAddNew = () => {
    form.resetFields();              // پاک کردن همه فیلدها
    setJournalFormData(null);       // حذف داده‌های قبلی
    setPreviewImage(null);          // حذف عکس قبلی
    setIsModalOpen(true);           // باز کردن مودال
  };

  useEffect(() => {

    fetchJournalList()

  }
    , []);


  // useEffect(() => {
  //   if (isModalOpen) {

  //     getJournalList().then((response) => {
  //       const rawData = Array.isArray(response?.data) ? response.data : [];
  //       setJournals(rawData);
  //     });
  //   }
  // }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen && journalFormData) {
      debugger
      form.setFieldsValue({
        title: journalFormData.title,
        abbreviation: journalFormData.abbreviations,
        url: journalFormData.url,
        description: journalFormData.description,
        issn: journalFormData.issn,
        impactfactor: journalFormData.impactFactor,
        onlineISSN: journalFormData.onlineISSN,
        about: journalFormData.about
      });
    }
  }, [isModalOpen, journalFormData]);


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const navigate = useNavigate();

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Cover Image',
      dataIndex: 'coverImage',
      key: 'coverImage',
      width: '20%',
      render: (coverImageUrl) => {
        console.log('coverImageUrl:', coverImageUrl?.replace(/\\/g, '/'));
        return (
          <img
            src={`https://files.journalapi.rhc.ac.ir/${coverImageUrl?.replace(/\\/g, '/')}`}
            alt="Cover"
            style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4 }}
          />
        );
      }
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: '30%',
      ...getColumnSearchProps('title'),

    },
    {
      title: 'Abbreviation',
      dataIndex: 'abbreviation',
      key: 'abbreviations',
      width: '20%',

    },

    {
      title: 'Issues',
      dataIndex: 'issueCount',
      key: 'issue',
      width: '20%',

    },
    {
      title: 'Articles',
      dataIndex: 'articleCount',
      key: 'articles',
      width: '20%',

    },

    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: '20%',
      render: (text) => truncateText(text),
      render: (text) => (
        <Tooltip title={text}>
          {truncateText(text)}
        </Tooltip>
      ),


    },

    {
      title: 'about',
      dataIndex: 'about',
      key: 'about',
      width: '20%',
      render: (text) => truncateText(text),
      render: (text) => (
        <Tooltip title={text}>
          {truncateText(text)}
        </Tooltip>
      ),
    },

    {
      title: 'Issn',
      dataIndex: 'issn',
      key: 'issn',
      width: '20%',
    },

    {
      title: 'Impact Factor',
      dataIndex: 'impactFactor',
      key: 'impactfactor',
      width: '20%',

    },

    {
      title: 'Online ISSN',
      dataIndex: 'onlineISSN',
      key: 'onlineissn',
      width: '20%',

    },


    {
      title: <div style={{ textAlign: 'center' }}>Actions</div>,
      key: 'action',
      width: '10%',

      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => handleEdit(record)}
            className="action-btn edit-btn"
            ghost
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this reviewer?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button className="action-btn delete-btn" danger ghost>
              Delete
            </Button>
          </Popconfirm>
          <Button className="action-btn issue-btn" ghost style={{ color: '#52c41a', borderColor: '#52c41a' }} onClick={() => showIssueModal(record)}
          >
            Set Issues
          </Button>
        </Space>
      ),
    },


  ];
  const handleEdit = async (record) => {
    try {
      const response = await getJournalDetails(record.id);
      if (response?.data) {
        const journalData = response.data;

        setJournalFormData(journalData);

        if (journalData.coverImageURL) {
          const fullImageURL = `https://files.journalapi.rhc.ac.ir/${journalData.coverImageURL.replace(/\\/g, '/')}`;
          setPreviewImage(fullImageURL);

          // 👇 اینم اضافه کن تا مقدار عکس داخل فرم هم ست بشه
          form.setFieldsValue({
            coverImage: {
              name: journalData.coverImageURL.split('/').pop(),
              url: fullImageURL,
              status: 'done',
              uid: '-1',
            },
          });
        } else {
          setPreviewImage(null);
          form.setFieldsValue({ coverImage: undefined });
        }

        setIsModalOpen(true);
      } else {
        message.error("Failed to load journal data");
      }
    } catch (error) {
      console.error("Error loading journal:", error);
      message.error("Error loading journal data");
    }
  };


  const handleDelete = async (record) => {

    console.log("Deleting journal with id:", record.id);

    try {
      await deleteJournal(record.id);
      message.success("Journal Deleted Successfully");
      fetchJournalList();
    } catch (err) {
      message.error("Error deleting Journal");
      console.error(err);
    }
  };

  // const handleFinish = async (values) => {
  //   try {
  //     const fileInput = document.querySelector('input[type="file"]');
  //     // const file = fileInput.files[0];

  //     const formData = new FormData();
  //     formData.append('coverImage', values.coverImage.target.files[0]);
  //     formData.append('title', values.title);
  //     formData.append('abbreviations', values.abbreviation);
  //     formData.append('url', values.url);

  //     const response = await createJournal(formData);

  //     if (response?.result?.result === true) {
  //       message.success('Journal added successfully');
  //       setIsModalOpen(false);
  //       setPreviewImage(null);
  //       form.resetFields();
  //       // Refresh data 
  //       fetchJournalList();
  //     } else {
  //       message.error('Failed to add journal');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting journal:', error);
  //     message.error('There was an error adding the journal');
  //   }
  // };

  const handleFinish = async (values) => {
    try {
      const fileInput = document.querySelector('input[type="file"]');
      const formData = new FormData();

      if (fileInput?.files[0]) {
        formData.append('coverImage', fileInput.files[0]);
      }

      formData.append('title', values.title);
      formData.append('abbreviations', values.abbreviation);
      formData.append('url', values.url);
      formData.append('description', values.description);
      formData.append('about', values.about);
      formData.append('issn', values.issn);
      formData.append('impactFactor', values.impactfactor);
      formData.append('onlineISSN', values.onlineISSN);

      let response;

      if (journalFormData?.id) {
        // اگر داریم ادیت می‌کنیم
          formData.append('JournalId', journalFormData.id);
        response = await editJournal(formData);
      } else {
        // اگر داریم اضافه می‌کنیم
        response = await createJournal(formData);
      }

      if (response?.result?.result === true) {
        message.success(journalFormData?.id ? 'Journal edited successfully' : 'Journal added successfully');
        setIsModalOpen(false);
        setPreviewImage(null);
        form.resetFields();
        fetchJournalList();
      } else {
        message.error(journalFormData?.id ? 'Failed to edit journal' : 'Failed to add journal');
      }
    } catch (error) {
      console.error('Error submitting journal:', error);
      message.error('There was an error submitting the journal');
    }
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  return (

    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button className="add-new-btn" onClick={handleAddNew}>
          + Add New Journal
        </Button>
      </div>
      <Modal
        title="Add New Journal"
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          {/* <Form.Item
            name="coverImage"
            label="Cover Image"
            valuePropName="file"
            rules={[{ required: true, message: 'Please upload a cover image!' }]}
          >
            <>
              <Input type="file" accept="image/*" onChange={handleImageChange} />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{ width: '100%', maxHeight: 200, marginTop: 8, objectFit: 'contain', border: '1px solid #eee', padding: 4 }}
                />
              )}
            </>
          </Form.Item> */}

          <Form.Item
            name="coverImage"
            label="Cover Image"
            valuePropName="file"
            rules={[
              {
                required: !previewImage,
                message: 'Please upload a cover image!',
              },
            ]}
          >
            <>
              <Input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    width: '100%',
                    maxHeight: 200,
                    marginTop: 8,
                    objectFit: 'contain',
                    border: '1px solid #eee',
                    padding: 4,
                  }}
                />
              )}
            </>
          </Form.Item>


          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: 'Please enter the title' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="abbreviation"
            label="Abbreviation"
            rules={[{ required: true, message: 'Please enter the abbreviation' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="url"
            label="Journal URL"
            rules={[{ required: true, message: 'Please enter the URL' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: 'Please enter the Description' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="about"
            label="About"
            rules={[{ required: true, message: 'Please enter the About' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="issn"
            label="Issn"
            rules={[{ required: true, message: 'Please enter the Issn' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="impactfactor"
            label="Impact Factor"
            rules={[{ required: true, message: 'Please enter the Impact Factor' }]}
          >
            <Input />
          </Form.Item>


          <Form.Item
            name="onlineISSN"
            label="Online ISSN"
            rules={[{ required: true, message: 'Please enter the Online ISSN' }]}
          >
            <Input />
          </Form.Item>



        </Form>
      </Modal>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        onRow={(record) => ({
          style: { cursor: 'pointer' },

        })}
        rowClassName={() => 'custom-row-hover'}

      />
      <Modal
        title={`${selectedJournal?.title} / Issues`}
        open={isIssueModalOpen}
        onCancel={() => setIsIssueModalOpen(false)}
        footer={null}
        width="70%"

      >
        <Issues />
      </Modal>

    </>
  );


};

export default JournalListTable;
